import React from 'react';
import { Star, CheckCircle2 } from 'lucide-react';
import { ProductReview } from '../../types';

interface ReviewFeedProps {
    reviews: ProductReview[];
    onReviewClick?: (id: string) => void;
}

export const ReviewFeed: React.FC<ReviewFeedProps> = ({ reviews, onReviewClick }) => {
    if (!reviews || reviews.length === 0) return null;

    // Helper to format date
    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('es-SV', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }).format(date);
    };

    return (
        <div className="space-y-6 mt-8">
            <h4 className="text-xl font-display font-bold uppercase italic text-white border-b border-zinc-900 pb-4">
                Comentarios Recientes
            </h4>
            
            <div className="space-y-6">
                {reviews.map((review) => (
                    <div 
                        key={review.id} 
                        className={`bg-zinc-950/30 border border-zinc-900 rounded-sm p-6 ${onReviewClick ? 'cursor-pointer hover:border-zinc-700 transition-colors' : ''}`}
                        onClick={() => onReviewClick?.(review.id)}
                    >
                        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-zinc-900 border border-zinc-800 rounded-full flex items-center justify-center text-white font-bold uppercase shrink-0">
                                    {review.customer_name.charAt(0)}
                                </div>
                                <div>
                                    <h5 className="text-sm font-bold text-white flex items-center gap-1.5">
                                        {review.customer_name}
                                        <span className="flex items-center gap-1 text-[9px] px-1.5 py-0.5 rounded-full bg-green-500/10 text-green-500 border border-green-500/20 uppercase font-mono tracking-widest ml-2">
                                            <CheckCircle2 size={10} /> Compra Verificada
                                        </span>
                                    </h5>
                                    <p className="text-[10px] text-zinc-500 font-mono tracking-widest uppercase mt-0.5">
                                        {formatDate(review.created_at)}
                                    </p>
                                </div>
                            </div>
                            
                            <div className="flex gap-1">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <Star 
                                        key={star} 
                                        size={14} 
                                        className={star <= review.rating ? "fill-white text-white drop-shadow-[0_0_5px_rgba(255,255,255,0.5)]" : "fill-transparent text-zinc-800"} 
                                    />
                                ))}
                            </div>
                        </div>

                        {review.comment && (
                            <p className="text-zinc-300 text-sm leading-relaxed whitespace-pre-wrap">
                                {review.comment}
                            </p>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
